import { render } from "./CommonSpinner.vue?vue&type=template&id=357c2fcc"
import script from "./CommonSpinner.vue?vue&type=script&lang=js"
export * from "./CommonSpinner.vue?vue&type=script&lang=js"

import "./CommonSpinner.vue?vue&type=style&index=0&id=357c2fcc&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__